import { DateTime } from 'luxon';
import { PageTitle } from '@library/components/PageTitle';
import { getSimulationNameHeaderText } from '@bo-utils/simulations';

export interface SimulationDetailsPageHeaderProps {
  awayTeamName?: string;
  homeTeamName?: string;
  isNewSimulation: boolean;
  scheduledAt?: string;
  simulationName?: string;
  simulationType?: 'CANDIDATE' | 'PUBLISHED';
}

export const SimulationDetailsPageHeader = ({
  awayTeamName = '',
  homeTeamName = '',
  isNewSimulation,
  scheduledAt = '',
  simulationName = '',
  simulationType = undefined
}: SimulationDetailsPageHeaderProps) => {
  const headerLabel = getSimulationNameHeaderText({
    isNewSimulation,
    simulationName,
    simulationType
  });

  return (
    <section className="border-soFresh-140 w-auto border-b px-6 py-3">
      <PageTitle
        title={`Simulation Details${
          isNewSimulation ? ' (New Simulation)' : ''
        }`}
      />

      <div className="flex w-full justify-between pt-4">
        <div className="flex flex-col">
          <span className="text-soClean-180 font-heebo text-xs font-light">
            {DateTime.fromISO(scheduledAt).toFormat('ccc h:mm a ZZZZ')}
          </span>
          <span className="text-soClean-100 font-heebo text-base font-bold">
            {awayTeamName} vs {homeTeamName}
          </span>
        </div>

        <span className="font-heebo text-soClean-100 text-xs font-medium">
          {headerLabel}
        </span>
      </div>
    </section>
  );
};
